import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { ICreateInvoice } from '../../pages/Invoices/InvoiceCreation/types/types';
import { INVOICE_CREATION_INITIAL_DATA } from '../../pages/Invoices/InvoiceCreation/consts/consts';
import { useStore } from '../../store';
import { HUB_MODALS } from '../../pages/Invoices/InvoiceHub/components/InvoiceHubModals';
import { IServerErrorResponse } from '../../types';

interface IProps {
    customerId: string;
    onSuccess: (data: any) => void;
}

export const useInvoiceCreationMutation = ({ customerId, onSuccess }: IProps) => {
  const setActiveModal = useStore(state => state.setActiveModal);
  const setError = useStore(state => state.setError);
  const navigate = useNavigate();
  const initialPayload = INVOICE_CREATION_INITIAL_DATA;
  return useMutation(
    'InvoiceCreationMutation',
    async () => {
      const res = await httpService.post(`${BASE_URL}/api/v2/user/${customerId}/invoice`, { ...initialPayload });
      return res.data;
    },
    {
      retry: 1,
      retryDelay: 1000,
      onSuccess: (res: ICreateInvoice) => {
        onSuccess(res);
      },
      onError: (error: IServerErrorResponse) => {
        navigate('/invoices');
        setTimeout(() => {
          setError(error);
          setActiveModal(HUB_MODALS.ERROR);
        }, 1500);
      },
    },
  );
};
